import { createApp } from 'vue'
import App from './App.vue'
import faviconPath from './assets/logo-simples-transparente.png'

let link = document.querySelector("link[rel~='icon']");
if (!link) {
  link = document.createElement('link');
  link.rel = 'icon';
  document.head.appendChild(link);
}
link.href = faviconPath;

createApp(App).mount('#app')
